import { tns } from 'tiny-slider'

addEventListener('DOMContentLoaded', _ => {
    const slider = tns({
        container: '.grid-carousel-wrapper',
        arrowKeys: true,
        nav: false,
        autoHeight: true,
        prevButton: '.grid-carousel-previous',
        nextButton: '.grid-carousel-next',
    })
})
